import { NextSeo } from 'next-seo'

import { benefitsOfCodingLandingPageSeo } from '@lib/seo'
import FirstFold from '@components/benefits-of-coding/first-fold'
import Benefits from '@components/benefits-of-coding/benefits'
import Testimonial from '@components/benefits-of-coding/testimonials'
import MinimalFooter from '@components/common/minimalistic-footer'

const BenefitsOfCoding = () => (
  <>
    <NextSeo {...benefitsOfCodingLandingPageSeo} />
    <FirstFold />
    <Benefits />
    <Testimonial />
    <MinimalFooter />
  </>
)

// export const getStaticProps = async () => {
//   return {
//     props: {},
//   }
// }

export default BenefitsOfCoding
